<template>
  <div>
            <el-table
            border
            :data="tableData"
            height="300"
            style="width: 100%">
            
            <el-table-column
            align="center" width="80">
            <template slot="header" slot-scope="scope">
                <!-- 
                 -->
                <el-button
                :disabled="viewFlag"
                size="mini" 
                type="primary"
                icon="el-icon-plus" 
                @click="handleAdd(scope.$index, scope.row)" circle></el-button>
            </template>
            <template slot-scope="scope">
                <!-- v-show="scope.row.viewFlag&&!scope.row.viewFlag" -->
                <el-button
                :disabled="viewFlag"
                size="mini"
                type="danger"
                icon="el-icon-delete" 
                @click="handleDelete(scope.$index, scope.row)" circle></el-button>
            </template>
            </el-table-column>

            <el-table-column
                v-for="(item,index) in headerData"
                :key="index"
            :label="item.label"
            :prop="item.prop">
            <template slot-scope="scope">
                <div v-if="item.type==='select'">
                    <el-select :disabled="viewFlag" v-model="scope.row[item.prop]" @change="(val)=>{changeSelectHandler(val,scope,item.prop)}" @blur="(val)=>{blurSeleHandler(val,scope,item.prop)}">
                        <el-option
                            v-for="(e,i) in item.list"
                            :key="i"
                            :label="e.dictValue"
                            :value="e.dictKey"
                        >
                        </el-option>
                    </el-select>
                    <div v-if="scope.row[item.prop+'validPropFlag']&&scope.row[item.prop+'emptyFlag']" style="color:red;font-size:12px;">请输入"{{item.label}}"</div>
                    <div v-if="scope.row[item.prop+'validPropFlag']&&scope.row[item.prop+'valideFlag']" style="color:red;font-size:12px;">"{{item.label}}"格式错误</div>
                </div>
                <div v-if="item.type==='input'">
                    <el-input :disabled="viewFlag" :maxlength="item.maxlength" v-model="scope.row[item.prop]" @input="(val)=>{changeInputHandler(val,scope,item.prop)}" @blur="(val)=>{blurInputHandler(val,scope,item.prop)}"></el-input>
                    <div v-if="scope.row[item.prop+'validPropFlag']&&scope.row[item.prop+'emptyFlag']" style="color:red;font-size:12px;">请输入"{{item.label}}"</div>
                    <div v-if="scope.row[item.prop+'validPropFlag']&&scope.row[item.prop+'valideFlag']" style="color:red;font-size:12px;">"{{item.label}}"格式错误</div>
                </div>
            </template>
            </el-table-column>
        </el-table>
  </div>
</template>

<script>
export default {
    props:{
        viewFlag:{
            type:Boolean,
            default(){
                return false;
            },
        },
        validProp:{
            type:Array,
            default(){
                return [];
            },
        },
        tableData:{
            type:Array,
            default(){
                return [];
            },
        },
        headerData:{      
            type:Array,
            default(){
                return [];
            },
        }
    },
    created(){
    },
    mounted(){
        
        this.tableData = [];
    },
    methods:{
        validateEmpty(val){

        },
        changeInputHandler(val,scope,prop){
            scope.row[prop+'emptyFlag'] = false;
            scope.row[prop+'valideFlag'] = false;
            console.log(scope);
            console.log(this.tableData);
            console.log(val);
            console.log(scope.row[prop+'validPropFlag']);
            setTimeout(() => {
                if(scope.row[prop+'validPropFlag']){
                    if(this.vdui.isEmpty(val)){
                        scope.row[prop+'emptyFlag'] = true;
                        return;
                    }
                    if(!this.$validation.money.test(val)){
                        scope.row[prop+'valideFlag'] = true;
                        return;
                    }
                }
                let self = this;
                this.$emit('handleData',{delItem:'',tableData:self.tableData});
            });
        },
        
        changeSelectHandler(val,scope,prop){
            scope.row[prop+'emptyFlag'] = false;
            scope.row[prop+'valideFlag'] = false;
            console.log(scope);
            console.log(this.tableData);
            console.log(val);
            setTimeout(() => {
                // if(this.vdui.isEmpty(val)){
                //     scope.row[prop+'emptyFlag'] = true;
                //     return;
                // }
                let self = this;
                this.$emit('handleData',{delItem:'',tableData:self.tableData});
            });
        },
        blurSeleHandler(val,scope,prop){
            scope.row[prop+'emptyFlag'] = false;
            scope.row[prop+'valideFlag'] = false;
            console.log(scope);
            console.log(this.tableData);
            console.log(val);
            setTimeout(() => {
                if(scope.row[prop+'validPropFlag']){
                    if(this.vdui.isEmpty(val.target.value)){
                        scope.row[prop+'emptyFlag'] = true;
                        return;
                    }
                }
                let self = this;
                this.$emit('handleData',{delItem:'',tableData:self.tableData});
            });
        },
        blurInputHandler(val,scope,prop){
            scope.row[prop+'emptyFlag'] = false;
            scope.row[prop+'valideFlag'] = false;
            console.log(scope);
            console.log(this.tableData);
            console.log(val);
            console.log(scope.row[prop+'validPropFlag']);
            setTimeout(() => {
                if(scope.row[prop+'validPropFlag']){
                    if(this.vdui.isEmpty(val.target.value)){
                        scope.row[prop+'emptyFlag'] = true;
                        return;
                    }
                    if(!this.$validation.money.test(val.target.value)){
                        scope.row[prop+'valideFlag'] = true;
                        return;
                    }
                }
                let self = this;
                this.$emit('handleData',{delItem:'',tableData:self.tableData});
            });
        },
        handleAdd(index, row) {
            // console.log(row);
            // let obj = {}
            // for (x in person) {
            //     obj += obj[x] + " ";
            // }
            let self = this;
            if(!this.tableData){
                this.tableData = [];
            }
            console.log();
            let obj = {};
            this.headerData.forEach(element => {
                obj[element.prop] = '';
                obj[element.prop+'emptyFlag'] = false;
                obj[element.prop+'valideFlag'] = false;
                if(self.validProp.includes(element.prop)){
                    obj[element.prop+'validPropFlag'] = true;
                }
                // self.validProp.forEach((ele,index)=>{
                //     console.log(ele);
                //     if(ele === element.prop){
                //         obj[element.prop+'validPropFlag'] = true;
                //     }
                // })
            });
            console.log(obj,this.tableData);
            this.tableData.push(obj);
        },
        handleDelete(index, row) {
            let self = this;
            this.tableData.splice(index, 1);
            this.$emit('handleData',{delItem:row,tableData:self.tableData});
        },
    },
}
</script>

<style>

</style>